import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    ApplicationInfoDto,
    ChangePasswordDto,
    SearchUsersParameters,
    UserClient,
    UserPersonalInformationDto,
    UserView
} from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    constructor(private readonly client: UserClient) {}

    async getById(id: number): Promise<UserView> {
        return await lastValueFrom(this.client.userGetByExternalId(id));
    }

    async search(body: SearchUsersParameters): Promise<UserView[]> {
        return await lastValueFrom(this.client.userSearch(body));
    }

    async changeUserInformation(body: UserPersonalInformationDto): Promise<void> {
        return await lastValueFrom(this.client.userUpdatePersonalInformation(body));
    }

    async getUserInformation(): Promise<UserPersonalInformationDto> {
        return await lastValueFrom(this.client.userGetPersonalInformation());
    }

    async getAuthenticatedUser(): Promise<UserView> {
        return await lastValueFrom(this.client.userGetAuthenticatedUser());
    }

    async getUserApplications(): Promise<ApplicationInfoDto[]> {
        return await lastValueFrom(this.client.userGetApplications());
    }

    async isLoggedIn(): Promise<boolean> {
        return await lastValueFrom(this.client.userIsLoggedIn());
    }

    async sendChangePasswordRequest(body: ChangePasswordDto): Promise<void> {
        return await lastValueFrom(this.client.userChangeUserPassword(body));
    }
}
